import { useMutation } from '@tanstack/react-query'
import { uploadFile, uploadVideo } from 'service/util'

export function useUploadFile() {
  return useMutation({
    mutationKey: ['upload-file'],
    mutationFn: uploadFile,
  })
}

export function useUploadVideo() {
  return useMutation({
    mutationKey: ['upload-video'],
    mutationFn: uploadVideo,
  })
}
